import React from 'react';
import EventCard from './EventCard';

const EventList = ({ events, isLoading }) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {[1, 2, 3, 4, 5, 6]?.map((i) => (
          <div key={i} className="bg-card rounded-xl overflow-hidden shadow-organic animate-pulse">
            <div className="h-64 md:h-56 lg:h-64 bg-muted" />
            <div className="p-4 md:p-5 lg:p-6 space-y-4">
              <div className="h-6 bg-muted rounded w-3/4" />
              <div className="h-4 bg-muted rounded w-1/2" />
              <div className="h-4 bg-muted rounded w-2/3" />
              <div className="h-10 bg-muted rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (events?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mb-4">
          <svg
            className="w-8 h-8 md:w-10 md:h-10 text-muted-foreground"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
          Etkinlik Bulunamadı
        </h3>
        <p className="text-sm md:text-base text-muted-foreground text-center max-w-md">
          Aradığınız kriterlere uygun etkinlik bulunamadı. Lütfen filtrelerinizi değiştirerek tekrar deneyin.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
      {events?.map((event) => (
        <EventCard key={event?.id} event={event} />
      ))}
    </div>
  );
};

export default EventList;